<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import IconLabel from '$lib/components/atoms/iconlabel/IconLabel.svelte';

	type T = $$Generic<string>;

	interface Props {
		options: { key: T; label?: string; icon?: string }[];
		defaultSelectedOption: T;
		hideTextOnMobile?: boolean;
		label?: string;
		class?: ClassValue;
		onSelectOption?: (option: T) => void;
	}

	const {
		options,
		defaultSelectedOption,
		hideTextOnMobile = false,
		label,
		class: classes,
		onSelectOption,
	}: Props = $props();

	let selectedIndex = $derived(Math.max(options.map(({ key }) => key).indexOf(defaultSelectedOption), 0));

	function onOptionClick(index: number) {
		selectedIndex = index;
		onSelectOption?.(options[index].key);
	}
</script>

<div class="flex flex-col gap-1 text-sm text-coloredneutral border-neutral-soft">
	{label}
	<div class={['flex gap-2', classes]}>
		{#each options as { label, icon }, index (label)}
			<button
				type="button"
				role="option"
				aria-selected={index === selectedIndex}
				class={['whitespace-nowrap flex justify-center items-center text-md rd-2 px-2 h-9 gap-1 b-0 cursor-pointer', index
					=== selectedIndex
					? 'bg-neutral-soft text-coloredneutral'
					: 'bg-transparent hover:bg-neutral-weak text-coloredneutral']}
				onclick={() => onOptionClick(index)}
			>
				<IconLabel {icon} {label} hideLabelOnMobile={hideTextOnMobile} tag="span" iconTag="span" />
			</button>
		{/each}
	</div>
</div>
